import React from "react";
import { Flex } from "./flex";
import { Grid } from "./grid";
import { Padding } from "./padding";
import { Disclosure, Transition } from "@headlessui/react";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NavBar = _ref => {
  var {
    children: _children,
    header
  } = _ref;
  return /*#__PURE__*/_jsxs(Grid, {
    align_self: "center",
    align_items: "center",
    justify_items: "center",
    children: [/*#__PURE__*/_jsxs(Grid, {
      className: "hidden md:grid",
      layout: "1-3",
      max_width: "xl",
      children: [header, /*#__PURE__*/_jsx(Flex, {
        align: "center",
        justify: "end",
        direction: "row",
        gap: "4",
        children: _children
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      className: "flex md:hidden",
      justify: "end",
      children: [header, /*#__PURE__*/_jsx(Padding, {
        y: "4",
        children: /*#__PURE__*/_jsx(Disclosure, {
          children: _ref2 => {
            var {
              open
            } = _ref2;
            return /*#__PURE__*/_jsxs(Flex, {
              direction: "column",
              align: "end",
              justify: "end",
              children: [/*#__PURE__*/_jsxs(Disclosure.Button, {
                children: [/*#__PURE__*/_jsx("span", {
                  className: "sr-only",
                  children: "Open main menu"
                }), open ? /*#__PURE__*/_jsx(XIcon, {
                  className: "block h-8 w-8 my-4",
                  "aria-hidden": "true"
                }) : /*#__PURE__*/_jsx(MenuIcon, {
                  className: "block h-8 w-8 mt-4",
                  "aria-hidden": "true"
                })]
              }), /*#__PURE__*/_jsx(Transition, {
                enter: "transition duration-100 ease-out",
                enterFrom: "transform scale-95 opacity-0",
                enterTo: "transform scale-100 opacity-100",
                leave: "transition duration-75 ease-out",
                leaveFrom: "transform scale-100 opacity-100",
                leaveTo: "transform scale-95 opacity-0",
                children: /*#__PURE__*/_jsx(Disclosure.Panel, {
                  children: /*#__PURE__*/_jsx(Flex, {
                    align: "end",
                    justify: "center",
                    direction: "column",
                    gap: "4",
                    children: _children
                  })
                })
              })]
            });
          }
        })
      })]
    })]
  });
};
//# sourceMappingURL=nav_bar.js.map